/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';

import ExerciseFilter from './ExerciseFilter';
import ExerciseMetricsContainers from './ExerciseMetricsContainer';
import SCOverviewChart from './SCOverviewChart';
import ForcePlateDatePicker from '../../../force-plate-dashboard/components/presentational/ForcePlateDatePicker';
import ForcePlateDropDown from '../../../force-plate-dashboard/components/presentational/ForcePlateDropDown';
import Button from '../../../../shared/_TBComponents/Button';
import { setIsLegendInfoModalShowing, setSelectedAthletePerformance } from '../../ducks/sportCoachDashboardActions';
import { BoxShadow } from '../../../../shared/GlobalStyles';

const DashboardContainer = styled('div')`
  background-color: #FFFFFF;
  border-radius: 10px;
  box-shadow: ${BoxShadow};
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 15px 15px 7px 15px;
  padding: 16px;
  position: relative;
`;

const DateOptionsContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .printBtn {
    border: 1px solid #808080;
    border-radius: 50%;
    height: 35px;
    margin-left: 10px;
    padding: 3px;
    width: 35px;
  }
`;

const LegendAndIcon = styled('div')`
  align-items: center;
  display: flex;
  margin-left: 17px;
  width: 230px;

  button {
    background: transparent!important;
  }

  svg {
    border: 1px solid #808080;
    border-radius: 50%;
    height: 20px;
    padding: 3px;
    width: 20px;
  }
`;

const LegendTitle = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  margin-right: 5px;
`;

const MenuOptionsContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
`;

const OptionsHeader = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const ViewOnlyOverview = () => {
  const {
    athleteList,
    endDateCal,
    group,
    scDashData,
    selectedAthletePerformance,
    startDateCal,
  } = useSelector((state) => state.sportCoachDashboard.data);

  const dispatch = useDispatch();

  const athleteDropdownList = useMemo(() => {
    if (!scDashData || athleteList.length === 0) return [];
    return [{ fullName: 'View Group', userId: null }, ...athleteList];
  }, [scDashData, athleteList]);

  const emptyFunction = () => undefined;

  const handleLegendInfoClick = () => {
    dispatch(setIsLegendInfoModalShowing(true));
  };

  const setAthlete = (option) => {
    if (option.fullName === 'View Group') {
      dispatch(setSelectedAthletePerformance(null, false));
    } else {
      dispatch(setSelectedAthletePerformance(option, true));
    }
  };

  const renderOptionsHeader = () => (
    <OptionsHeader>
      <MenuOptionsContainer>
        <ForcePlateDropDown
          defaultOption={group || {}}
          disabled
          headerWidthPx={175}
          label='name'
          list={['']}
          placeholder='Select a Group'
          readOnly
          selectItemFunction={emptyFunction}
        />
        {scDashData && (
          <ForcePlateDropDown
            defaultOption={selectedAthletePerformance || {}}
            headerWidthPx={175}
            label='fullName'
            list={athleteDropdownList}
            placeholder='Select an Athlete'
            selectItemFunction={setAthlete}
          />
        )}
        <ExerciseFilter />
      </MenuOptionsContainer>
      <DateOptionsContainer>
        <ForcePlateDatePicker
          disabled
          endDate={endDateCal.toDate()}
          setEndDate={emptyFunction}
          setStartDate={emptyFunction}
          startDate={startDateCal.toDate()}
        />
      </DateOptionsContainer>
    </OptionsHeader>
  );

  return (
    <>
      <DashboardContainer>
        {renderOptionsHeader()}
        <SCOverviewChart />
      </DashboardContainer>
      <LegendAndIcon>
        <LegendTitle>
          Key Performance Exercises
        </LegendTitle>
        <Button
          aria-label='Show key performance exercises info modal'
          bgColor='#00000000'
          disabled={!scDashData}
          icon='info'
          iconColor='#979797'
          iconOnly
          noBorder
          onClick={handleLegendInfoClick}
          rounded
        />
      </LegendAndIcon>
      <ExerciseMetricsContainers />
    </>
  );
};

export default ViewOnlyOverview;
